module.exports = "https://static.uacdn.net/production/_next/static/images/start-screen-nudge-0f91d7624f4c33ae9a1703874537078e.svg";